module.exports = __webpack_public_path__ + "img/160023.71a2aa18.png";